import { SortDefinition } from '../../../shared/models/sort-definition';

export interface TechniqueAnimationState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: TechniqueAnimationState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'nom' },
};
